


























import {Component, Prop, Vue} from "vue-property-decorator";

import MemberCard from "@/components/community/_memberCard.vue";
import {mapGetters} from "vuex";
import UserCard from "@/components/user/_userCard.vue";

@Component({
    computed: {...mapGetters(["user"])},
    components: {MemberCard, UserCard},
})
export default class FollowerList extends Vue {
    @Prop() userId!: any;
    private followerList: any = [];
    private totalCnt: number = 0;
    private limit: number = 10;
    private offset: number = 0;
    private search: string = '';
    private user !: any;

    channel_id: string = '';

    mounted() {
        if (this.$route.params.channel_id) {
            this.channel_id = this.$route.params.channel_id;
        }
        else {
            this.channel_id = this.userId;
        }
        this.fetch();
    }

    fetch() {
        const obj = {
            limit: this.limit,
            offset: this.offset,
            search: this.search
        }
        //userId로 넘기는 부분인데 params 이름이 channel_id임
        this.$api.followerList(obj, this.channel_id)
            .then((res: any) => {
                this.followerList = res.result;
                this.totalCnt = res.totalCount;

            })
            .catch((err: any) => {

            })
    }
    reFetch(){
        this.fetch();
        this.$store.dispatch('reloadUserInfo');
    }
}
